import { prepareDocumentUrl } from '../../misc/requests';
import { FILE_EXTENSIONS } from '../../helpers/form.helper';
import { BaseIcon } from '..';

import './SummaryHelpers.scss';

const getLastItem = (path) => path.substring(path.lastIndexOf('/') + 1);

const SummaryFile = ({ name, type }) => {
  let icon = null;

  switch (type) {
    case FILE_EXTENSIONS.DOC:
    case FILE_EXTENSIONS.DOCX:
      icon = <BaseIcon icon="file-type-doc" />;
      break;
    case FILE_EXTENSIONS.PDF:
      icon = <BaseIcon icon="file-type-pdf" />;
      break;
    case FILE_EXTENSIONS.PNG:
      icon = <BaseIcon icon="file-type-png" />;
      break;
  }

  return (
    <>
      <span className="summary-file__icon">{icon}</span>
      <span className="summary-file__name" data-testid="summary-file-name">
        {name}
      </span>
    </>
  );
};

const SummaryLink = ({ href, download, key, children }) => {
  const handleDownload = async (e) => {
    e.preventDefault();

    const uuid = getLastItem(href);
    const response = await prepareDocumentUrl(href, uuid, download);
    if (download) {
      window.location.assign(response);
    } else {
      window.open(response, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <a
      href={href}
      onClick={handleDownload}
      target="_blank"
      rel="noopener noreferrer"
      className="summary-file__link link--underlined"
      download={download}
      key={key}
    >
      {children}
    </a>
  );
};

const SummaryNewTab = ({ file }) => {
  const handleClick = async (e) => {
    e.preventDefault();

    const uuid = getLastItem(file.file);
    const response = await prepareDocumentUrl(file.file, uuid);
    window.open(response, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={file.file}
      target="_blank"
      rel="noopener noreferrer"
      className="summary-file__link link--underlined"
      key={file.id}
      onClick={handleClick}
    >
      <SummaryFile name={file.name} type={file.name.split('.').pop()} />
    </a>
  );
};

export const SummaryFilesList = ({ files, download }) =>
  files && files.length
    ? files.map((file) =>
        download ? (
          <div className="summary-file" key={file.id}>
            <SummaryLink href={file.file} download={download}>
              <SummaryFile name={file.name} type={file.name.split('.').pop()} />
            </SummaryLink>
            <SummaryLink href={file.file}>
              <span className="summary-file__icon summary-file__icon--open">
                <BaseIcon icon="openFile" />
              </span>
            </SummaryLink>
          </div>
        ) : (
          <SummaryNewTab file={file} key={file.id} />
        )
      )
    : '-';
